import React from 'react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { MOCKUP_ALT, MOCKUP_URL } from '../../data/images';
export function HeroSection() {
  return <section className="bg-brand-paper px-5 pb-12 pt-10 lg:px-8 lg:pb-16 lg:pt-14" data-id="element-102" data-mp="16n9vt7b60gc1">
      <div className="mx-auto max-w-4xl text-center" data-id="element-103" data-mp="12ly48w8qdl17">
        <p className="font-body text-[11px] font-bold uppercase tracking-[0.18em] text-brand-pink sm:text-[12px]" data-id="element-104" data-mp="12n94im2ywank">
          For Hair Extension Instructors &amp; Beauty Educators
        </p>

        <h1 className="mt-4 font-display text-[2.6rem] font-bold leading-[1.02] tracking-[-0.015em] text-brand-charcoal sm:text-[3.4rem] lg:text-[4.25rem]" data-id="element-105" data-mp="1uefc1nl0pamv">
          Get Your Hair Extension Classes Ready in <Accent data-id="element-106" data-mp="1lbnx3dsxnwqh">Minutes — Not Hours!</Accent>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl font-body text-[16px] font-medium leading-relaxed text-brand-charcoal/80 sm:text-[18px]" data-id="element-107" data-mp="ew3ski05e2ij">
          Stop creating every lesson from scratch. Start teaching with a system already organized for you.
        </p>
      </div>

      <img src={MOCKUP_URL} alt={MOCKUP_ALT} width={1536} height={1024} loading="eager" decoding="async" className="mx-auto mt-8 block w-full max-w-[640px] object-contain lg:max-w-[920px]" style={{
      filter: 'drop-shadow(0 34px 40px rgba(120, 90, 60, 0.2))'
    }} data-id="element-108" data-mp="38h4jfeoibfh9" />

      <div className="mx-auto mt-8 max-w-2xl space-y-3 text-center text-[15px] leading-relaxed text-brand-charcoal/75 sm:text-[16px]" data-id="element-109" data-mp="2pq3janbnhdw4">
        <p className="font-semibold text-brand-charcoal" data-id="element-110" data-mp="2uhlhx4q7b2dx">
          Everything you need to organize your hair extension classes in one practical teaching system.
        </p>
        <p data-id="element-111" data-mp="2kq8rmhk1wka0">
          Get 6 digital volumes filled with technique guidance, structured lesson plans, student practice activities,
          worksheets, and assessment tools — designed to help you prepare faster and teach with more confidence.
        </p>
      </div>

      <CtaBlock label="Get my teaching system" className="mt-7" data-id="element-112" data-mp="2brwtluguuk7j" />

      <p className="mt-5 text-center font-body text-[12px] font-bold uppercase tracking-[0.14em] text-brand-gold-dark" data-id="element-113" data-mp="han974cxc0sv">
        6 Digital Volumes • Instant Access • One-Time Payment
      </p>
    </section>;
}